module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modalContents"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "500px"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('v-card', [_c('v-card-title', {
    class: _vm.modalColor,
    attrs: {
      "dark": ""
    }
  }, [_c('h2', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._t("title")], 2)]), _vm._v(" "), _c('v-card-text', [_vm._t("contents")], 2), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _vm._t("action")], 2)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31b03b92"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = 480
// module chunks = 1